import { RoundBadge } from '@peacecover/component';
import HorizontalScroll from '../../my-page/components/HorizontalScroll';

interface SceneCategoryTagListProps {
  isR19?: boolean;
  tags: string[];
  passage?: string;
  className?: string;
}

const PreviewHeaderItem = ({
  isR19 = false,
  tags,
  passage = '',
  className
}: SceneCategoryTagListProps) => {
  return (
    <section className={`px-[24px] ${className}`}>
      <HorizontalScroll>
        <div className="flex items-center gap-[8px]">
          {isR19 && (
            <div className="p-[1.5px]">
              <div className="border border-white text-white text-[11px] leading-[13px] font-bold rounded-full bg-[#EB1616] w-[17px] h-[17px] flex items-center justify-center">
                19
              </div>
            </div>
          )}
          {tags.map((tag) => (
            <RoundBadge
              key={tag}
              className="bg-[rgba(255,255,255,0.20)] text-pure-white leading-[13px]"
            >
              {tag}
            </RoundBadge>
          ))}
        </div>
      </HorizontalScroll>
      {passage && (
        <p
          className="text-[16px] leading-[26px] text-pure-white mt-[16px]"
        >
          {passage}
        </p>
      )}
    </section>
  );
};

export default PreviewHeaderItem;
